import { action, computed, makeObservable, observable } from "mobx";
import { AppSubStore, AppSubStoreArgs } from "@/store/types";

export class RenameFileModalStore extends AppSubStore {
  isOpen = false;
  fileId: string | null = null;
  fileName: string | null = null;
  inputValue = "";
  onRename: ((newFileName: string) => void) | null = null;

  constructor(injectedDeps: AppSubStoreArgs) {
    super(injectedDeps);

    makeObservable<this>(this, {
      isOpen: observable,
      fileId: observable,
      fileName: observable,
      inputValue: observable,
      onRename: false,
      fileExtension: computed,
      baseName: computed,
      isSubmitDisabled: computed,
      open: action,
      close: action,
      setInputValue: action,
      submit: action,
    });
  }

  get fileExtension(): string {
    if (!this.fileName) return "";
    const lastDot = this.fileName.lastIndexOf(".");
    if (lastDot <= 0) return "";
    return this.fileName.slice(lastDot);
  }

  get baseName(): string {
    if (!this.fileName) return "";
    const lastDot = this.fileName.lastIndexOf(".");
    if (lastDot <= 0) return this.fileName;
    return this.fileName.slice(0, lastDot);
  }

  get isSubmitDisabled(): boolean {
    return this.inputValue.trim().length === 0;
  }

  open({
    fileId,
    fileName,
    onRename,
  }: {
    fileId: string;
    fileName: string;
    onRename: (newFileName: string) => void;
  }) {
    this.fileId = fileId;
    this.fileName = fileName;
    this.inputValue = this.baseName;
    this.onRename = onRename;
    this.isOpen = true;
  }

  close() {
    this.isOpen = false;
    this.fileId = null;
    this.fileName = null;
    this.inputValue = "";
    this.onRename = null;
  }

  setInputValue(value: string) {
    this.inputValue = value;
  }

  submit() {
    if (this.isSubmitDisabled) return;
    this.onRename?.(this.inputValue.trim() + this.fileExtension);
    this.close();
  }
}
